<style>
.link:hover {
  color: #1976d2;
  cursor: pointer;
}
</style>

<template>
  <div align="center">
    <v-toolbar style="box-shadow: none !important">
      <v-toolbar-title> </v-toolbar-title>
      <v-spacer></v-spacer>

      <div style="margin-right: 10px; cursor: pointer" v-on:click="listdraft()">
        <v-btn depressed color="primary" to="/listRegister">
          Registration List
        </v-btn>
      </div>
    </v-toolbar>

    <div align="center" style="width: 50%; margin-top: 70px">
      <v-img
        alt="Vuetify Name"
        class="shrink mt-1 hidden-sm-and-down mb-10"
        contain
        min-width="100"
        src="../../assets/emaster-logo.png"
        width="210"
      />

      <template>
        <div v-if="selectedTabSearch === 'PART'">
          <v-text-field
            style="font-size: 16px"
            large
            rounded
            label=""
            placeholder="Please type Part Number"
            solo
            hide-details
            height="60"
            v-model="search_part"
            append-icon="search"
            @click:append="searchMaterial()"
            v-on:keyup.enter="searchMaterial()"
          ></v-text-field>

          <!-- <div style="margin-top: 5px; display: flex; align-items: center">
            <div class="mr-3">Operator :</div>
            <v-radio-group v-model="operator_part_number" mandatory row>
              <v-radio label="AND" value="AND"></v-radio>
              <v-radio label="OR" value="OR"></v-radio>
            </v-radio-group>
          </div> -->
        </div>

        <div v-if="selectedTabSearch === 'DESC'">
          <v-text-field
            style="font-size: 16px"
            large
            rounded
            label=""
            placeholder="Please type Material Number / Description / Basic Data Text / PN / Colloquial Name"
            solo
            height="60"
            hide-details
            v-model="search_desc"
            append-icon="search"
            @click:append="searchMaterial()"
            v-on:keyup.enter="searchMaterial()"
          ></v-text-field>

          <!-- <div style="margin-top: 5px; display: flex; align-items: center">
            <div class="mr-3">Operator :</div>
            <v-radio-group v-model="operator_desc" mandatory row>
              <v-radio label="AND" value="AND"></v-radio>
              <v-radio label="OR" value="OR"></v-radio>
            </v-radio-group>
          </div> -->
        </div>
      </template>

      <div>
        <v-btn
          v-for="(tab, i) in tabSearch"
          :key="i"
          depressed
          rounded
          class="ml-2 mt-10"
          :color="selectedTabSearch === tab.id ? '#E8F5E9' : ''"
          v-on:click="linkSearch(tab.id), (selectedTabSearch = tab.id)"
        >
          <v-icon v-if="selectedTabSearch === tab.id" color="green" class="mr-2"
            >mdi-check-circle</v-icon
          >
          {{ tab.label }}
        </v-btn>
      </div>

      <v-progress-linear
        :height="5"
        class="mt-10"
        color="success"
        indeterminate
        v-if="loading"
      ></v-progress-linear>
    </div>

    <div style="width: 90%; margin-bottom: 80px" v-if="container">
      <div class="mt-10">
        <v-card>
          <div>
            <v-toolbar style="box-shadow: none !important">
              <div style="font-size: 16px" class="mt-3">
                Result for <b>{{ result_search }}</b>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                v-if="
                  (divDesc == true || desserts == '') && storage_role === 'REQ'
                "
                color="primary"
                retain-focus-on-click="true"
                v-on:click="newregister()"
                depressed
              >
                <span class="mr-2">Register New Item</span>
              </v-btn>
            </v-toolbar>
          </div>

          <template>
            <div v-if="desserts == ''" align="center" style="padding: 30px">
              Data Not Found
            </div>

            <template>
              <v-data-table
                :headers="headers"
                :items="desserts"
                :items-per-page="50"
                class="elevation-1"
                v-if="desserts != ''"
                style="box-shadow: none !important"
              >
                <!-- <template v-slot:item.material_number="{ item }">
                  <div
                    :inner-html.prop="
                      item.material_number | highlight(result_search)
                    "
                  ></div>
                </template>

                <template v-slot:item.old_material_number="{ item }">
                  <div
                    :inner-html.prop="
                      item.old_material_number | highlight(result_search)
                    "
                  ></div>
                </template>

                <template v-slot:item.description="{ item }">
                  <div
                    :inner-html.prop="
                      item.description | highlight(result_search)
                    "
                  ></div>
                </template>

                <template v-slot:item.part_number="{ item }">
                  <div
                    :inner-html.prop="
                      item.part_number | highlight(result_search)
                    "
                  ></div>
                </template>

                <template v-slot:item.basic_data_text="{ item }">
                  <div
                    :inner-html.prop="
                      item.basic_data_text | highlight(result_search)
                    "
                  ></div>
                </template> -->

                <template v-slot:item.action="{ item }">
                  <div v-if="storage_role === 'REQ'">
                    <v-btn
                      v-if="item.plant !== plant_code"
                      small
                      depressed
                      color="success"
                      class="mt-2 mb-1"
                      v-on:click="openModalDetail(item, 'new')"
                    >
                      <span style="font-variant-caps: normal">Extend</span>
                    </v-btn>
                  </div>

                  <div>
                    <v-btn
                      v-if="item.plant === plant_code"
                      disabled
                      small
                      class="mt-2 mb-1"
                      color="success"
                    >
                      <span>Available</span>
                    </v-btn>
                  </div>

                  <v-btn
                    small
                    depressed
                    color="primary"
                    class="mb-2"
                    v-on:click="openModalDetail(item, 'detail')"
                  >
                    <span style="font-variant-caps: normal">Detail</span>
                  </v-btn>
                </template>
              </v-data-table>
            </template>
          </template>

          <v-dialog
            v-if="dialogDetailMaterial"
            v-model="dialogDetailMaterial"
            max-width="90%"
            scrollable
          >
            <detail-material-initial
              :data="detail_data"
              :type="type_detail"
              @closeDialog="dialogDetailMaterial = false"
            ></detail-material-initial>
          </v-dialog>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import DetailMaterialInitialVue from "../component/DetailMaterialInitial.vue"

export default {
  components: {
    "detail-material-initial": DetailMaterialInitialVue,
  },
  methods: {
    searchMaterial() {
      var self = this
      var type_search = self.type_search
      var url = ""
      var operator = ""
      var val = ""

      if (type_search == "DESC") {
        val = this.search_desc
        url = this.base_url + "search/initial_material"
        operator = this.operator_desc
        this.result_search = this.search_desc
      } else if (type_search == "PART") {
        val = this.search_part
        url = this.base_url + "search/initial_material_partno"
        operator = this.operator_part_number
        this.result_search = this.search_part
      }

      if (val) {
        self.loading = true
        self.container = false

        this.axios
          .post(url, {
            param: val,
            operator: operator,
          })
          .then(function(response) {
            self.result = response.data
            self.desserts = response.data
            self.loading = false
            self.container = true
          })
          .catch(function(error) {
            self.result = error
            self.loading = false
            self.container = true
          })
      }
    },
    linkSearch(mode = "") {
      if (mode == "DESC") {
        this.divDesc = true
        this.divPart = false
        this.type_search = "DESC"
      } else if (mode == "PART") {
        this.divDesc = false
        this.divPart = true
        this.type_search = "PART"
      }
      this.container = false
    },
    extended(id) {
      var server_code = "NCA"
      this.$router.push({
        path: "/addRegister/" + btoa(server_code) + "/extended/" + btoa(id),
      })
    },
    newregister() {
      var server_code = "NCD==="
      this.$router.push({ path: "/addRegister/" + btoa(server_code) })
    },
    listdraft() {
      this.$router.push({ path: "/listRegister" })
    },
    getPlant(material_number) {
      var self = this
      var url = this.base_url + "dropdown/plant_detail/" + material_number
      this.axios.get(url).then(function(response) {
        self.list_detail_plant = response.data
      })
      self.dialog_plant = true
    },
    openModalDetail(item, type) {
      this.detail_data = item
      this.type_detail = type
      this.dialogDetailMaterial = true
    },
  },
  mounted() {
    if (this.storage_role != "REQ" && this.storage_role != "CAT") {
      this.$router.push("/login")
    }

    this.server_select = this.storage_server
  },
  data() {
    return {
      checkedServer: [],
      loading: false,
      search: "",
      search_desc: "",
      search_part: "",
      result_search: "",
      type_detail: "detail",
      company_name: "PT. Cipta Kridatama",
      name: "Registration",
      title: "Search Material",
      dialog: false,
      container: false,
      selected: [],
      totalDraft: 0,
      result: [],
      list_server_code: [],
      server_code: "",
      server_select: "",
      dialog_plant: false,
      list_detail_plant: [],
      type_search: "PART",
      divDesc: false,
      divPart: true,
      detail_data: null,
      dialogDetailMaterial: false,
      selectedTabSearch: "PART",
      tabSearch: [
        {
          id: "PART",
          label: "Search By Part Number",
        },
        {
          id: "DESC",
          label: "Search By Part Description",
        },
      ],
      operator_part_number: null,
      operator_desc: null,

      headers: [
        { text: "Material Number", value: "material_number", width: "180" },
        {
          text: "Old Material Number",
          value: "old_material_number",
          width: "180",
        },
        { text: "Description", value: "description", width: "180" },
        { text: "Basic Data Text", value: "basic_data_text", width: "180" },
        // { text: "Colloquial Name", value: "colloquial_name" },
        // { text: "Manufacturer", value: "manufacturer" },
        { text: "Part No", value: "part_number", width: "120" },
        { text: "Plant", value: "plant_name", width: "100" },
        { text: "Action", value: "action", sortable: false, width: "160" },
      ],
      desserts: [],

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      departement_id: atob(localStorage.getItem("departement_id")),
      departement_desc: atob(localStorage.getItem("departement_desc")),
      plant_code: atob(localStorage.getItem("plant_code")),
    }
  },
  filters: {
    highlight: function(value, query) {
      return value.replace(
        new RegExp(query, "ig"),
        "<span style='background-color: #FFECB3'>" +
          query.toUpperCase() +
          "</span>"
      )
    },
  },
}
</script>
